import React from "react"
import PropTypes from "prop-types"
import { Section, Spacer, CmsImage } from "@bw/bits"
import { Teasers } from "@bw/modules"
import { Teaser } from "@bw/partials"
import { Checkbox } from "@bw/forms"
import { Formik, Form, Field } from "formik"

const Articles = ({ categories, articles }) => {
  const [filter, setFilter] = React.useState([])

  const filteredCategories = React.useMemo(() => {
    if (filter.length > 0) {
      return categories.filter(c => filter.includes(c.slug))
    } else {
      return categories
    }
  }, [categories, filter])

  return (
    <>
      <Formik
        initialValues={{ categories: [] }}
        onSubmit={values => {
          setFilter([...values.categories])
        }}
      >
        {({ submitForm }) => (
          <Form
            onChange={() => {
              submitForm()
            }}
          >
            <Spacer direction="row">
              {categories.map((item, i) => (
                <Field
                  key={i}
                  value={item.slug}
                  name="categories"
                  component={Checkbox}
                  title={item.title}
                  checked={filter.includes(item.slug)}
                />
              ))}
            </Spacer>
          </Form>
        )}
      </Formik>
      {filteredCategories.map((category, i) => {
        const articlesInCategory = articles.filter(
          article => article.category?.slug === category.slug
        )

        if (articlesInCategory.length === 0) {
          return null
        }

        return (
          <Section key={i}>
            <h3 style={{ marginTop: 0 }}>{category.title}</h3>
            <Teasers>
              {articlesInCategory.map((item, k) => (
                <Teaser
                  key={k}
                  title={item.title}
                  excerpt={item.teaserExcerpt}
                  image={
                    <CmsImage
                      src={item.teaserImage || "/placeholder-teaser.jpg"}
                      alt={item.title}
                    />
                  }
                  to={item.slug}
                />
              ))}
            </Teasers>
          </Section>
        )
      })}
    </>
  )
}

Articles.propTypes = {
  categories: PropTypes.array,
  articles: PropTypes.array,
}

export { Articles }
